import { useSelector } from 'react-redux';

export const useShutdownAccesses = () => {
  const userInfo = useSelector((state) => state.authentication.userInfo);
  const canDelete = true;
  const canChange = true;

  return { canChange, canDelete };
};
